
const DynamicForm = (
    ParentFormJSON,
    formData,
    updatedValues,
    actionRequired
) => {
    // Initialize jsonKey to store the form data
    let jsonKey = {};

    // Recursive function to render form fields
    const renderFormFields = (fields, formData) => {
        return fields?.map((field) => {
            const shouldShowField = evaluateFieldConditions(field, formData);

            // If the field shouldn't be shown, return null or undefined
            if (!shouldShowField) return null;

            // If the field is a fieldset, render its components recursively
            if (field?.type === "fieldset") {
                return renderFormFields(field?.components, formData);
            } else {
                return renderFieldComponent(field, formData, jsonKey);
            }
        });
    };

    // Handle rendering of individual field components
    const renderFieldComponent = (field, formData, jsonKey) => {
        const fieldValue = formData[field.key] !== undefined ? formData[field.key] : "";

        if (field.type === "file" || field.type === "signature") {
            // Handle signature and file components separately if needed
            return null; // Placeholder for signature/file rendering
        } else if (field.type === "button") {
            // Buttons shouldn't be returned as form fields
            return null;
        } else {
            // Add field value to jsonKey based on field label
            if (fieldValue !== "") {
                // Formatting the value to be more readable
                const formattedValue = fieldValue.replace(/(?!^)([A-Z])/g, " $1");
                const formattedLabel = formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
                jsonKey[field.label] = formattedLabel;
            }
        }
    };

    const renderUpdatedFormFields = (fields) => {
        return fields
            .map((field) => {
                jsonKey['Comment'] = field.Comment;
            })
    };

    const renderActionRequiredComponent = (fields) => {
        for (const key in fields) {
            if (fields.hasOwnProperty(key)) {
                const value = fields[key];
                const fieldName = key.charAt(0).toUpperCase() + key.slice(1); // Capitalizing the first letter
                jsonKey[fieldName] = value;
            }
        }
    };

    // Render the form fields based on ParentFormJSON
    renderFormFields(ParentFormJSON, formData);

    renderUpdatedFormFields(updatedValues);

    renderActionRequiredComponent(actionRequired);

    // Return the jsonKey with the accumulated values
    return jsonKey;
};


// **************************************************************************************
// **************************************************************************************

const evaluateTrigger = (trigger, isVisible, formData) => {
    // if no trigger exists return it's previous execution display value
    if (!trigger) return isVisible;
    const { type, simple } = trigger;
    if (type === "simple") {
        const { show, when, eq } = simple;

        const field = formData[when];
        return show === (field === eq);
    }
    // if trigger doesn't meet it's criteria return it's previous execution display value
    return isVisible;
};

const evaluateTriggers = (logics, display, formData) => {
    // default hidden value or display value
    let isVisible = display;
    // multiple triggers
    logics?.forEach((logic) => {
        const { trigger, actions } = logic;
        const shouldShow = evaluateTrigger(trigger, isVisible, formData);
        if (shouldShow) {
            actions?.forEach((action) => {
                const { name, type, property, state } = action;
                if (type === "property" && property) {
                    if (property.value === "hidden") {
                        if (state == true) {
                            isVisible = false;
                        } else {
                            isVisible = true;
                        }
                    }
                }
            });
        }
    });
    return isVisible;
};

const evaluateFieldConditions = (field, formData) => {
    // const {conditional = {},hidden = false,logic = [],components=[]} = field;
    const { conditional, hidden, logic, components } = field;

    // 1. Return Default Value (hidden) (if no conditional and no logic exists)
    // 2. If Conditinal exists first priority will be given to show Value irrespective of hidden value(Default Value)
    // or Logic results
    // and if condition doesn't met Return Default Value(hidden value)
    // 3. Even if logic exists display priority will be given to show value in conditional or based on logic result

    // Default Value

    var display = hidden === undefined ? true : !hidden;

    // Return Default Value no conditional and no logic
    if (!conditional && !logic) {
        if (!display) {
            //if display is false delete key value in formData
            return display;
        }
        return display;
    }

    // Check conditional
    if (conditional) {
        const { show, when, eq } = conditional;
        var display_cdn = show === true ? true : false;
        const whenValue = formData[when];

        //when it meets conditional
        if (whenValue === eq) {
            if (!display_cdn) {
                //if show is false delete key value in formData
                return display_cdn;
            }
            return display_cdn;
        }

        // when it doesn't meet conditional
        else {
            display_cdn = !display_cdn; // bcoz it doen't met the conditional so reversing show value
            if (!display_cdn) {
                //if show is false delete key value in formData
                return display_cdn;
            }
            return display_cdn;
        }
    }

    // No conditional
    else if (!conditional) {
        // if logic exists
        if (logic) {
            // evaluate multiple logics(multiple triggers and multiple actions)
            const isVisible = evaluateTriggers(logic, display, formData);

            if (!isVisible) {
                return isVisible;
            }
            return isVisible;
        }
    }
};

// **************************************************************************************
// **************************************************************************************

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export default async function generateJson(ParentFormJSON, SubmittedData) {

    // Get the filled JSON data from DynamicForm
    const jsonResult = DynamicForm(ParentFormJSON, SubmittedData?.values, SubmittedData?.updatedValues, SubmittedData?.actionRequired);

    // Log the result to check the generated JSON
    return jsonResult;  // Return the jsonKey
}

